import { render, staticRenderFns } from "./CollecteMenuIcon.vue?vue&type=template&id=319b9946"
import script from "./CollecteMenuIcon.vue?vue&type=script&lang=js"
export * from "./CollecteMenuIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports